import TemplateView from '../../../../TemplateView'
import CounterWithProgressBar from "../../../../components/counterCPT/CounterWithProgressBar"
import {HierarchyLevels} from 'constants'
import {customerNameLower, projectNameLower, taskNameLower} from '../../../../util/pluralizeUtils'
import messageResource from '../../../../messageResource'

export default class ViewerManagementCounters extends TemplateView {
    constructor() {
        super(null)

        this.state = {
            customers: 0,
            projects: 0,
            tasks: 0,
        }

        this.onStateChanged(() => {
            const customers = this.state.customers
            this.customersCounter.setState({
                maxValue: customers,
                curValue: customers,
                active: customers > 0,
                pale: customers === 0,
                title: messageResource.getMessage('userlist.work_assignments.active') + " " + customerNameLower(customers)
            })

            const projects = this.state.projects
            this.projectsCounter.setState({
                maxValue: projects,
                curValue: projects,
                active: projects > 0,
                pale: projects === 0,
                title: messageResource.getMessage('userlist.work_assignments.active') + " " + projectNameLower(projects)
            })

            const tasks = this.state.tasks
            this.tasksCounter.setState({
                maxValue: tasks,
                curValue: tasks,
                active: tasks > 0,
                pale: tasks === 0,
                title: messageResource.getMessage('userlist.work_assignments.open') + " " + taskNameLower(tasks)
            })
        })
    }

    templateHtml() {
        return '<div class="workAssignmentsTab_viewerManagementCounter">' +
               '   <div class="customers"></div>' +
               '   <div class="projects"></div>' +
               '   <div class="tasks"></div>' +
               '</div>'
    }

    afterRender() {
        const $customers = this.find('.customers')
        this.customersCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.CUSTOMER,
            hasProgressBar: true,
        }).init($customers)

        const $projects = this.find('.projects')
        this.projectsCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.PROJECT,
            hasProgressBar: true,
        }).init($projects)

        const $tasks = this.find('.tasks')
        this.tasksCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.TASK,
            hasProgressBar: true,
        }).init($tasks)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsTab/components/ViewerManagementCounters.js